import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/internet-phone.png'
import _imports_1 from '../assets/voip.png'
import _imports_2 from '../assets/business-phone.png'
import _imports_3 from '../assets/home-phone.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-6" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Internet Telephony")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"30px","font-weight":"bold"} }, "Jtel VOIP Service Provider", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mt-4" }, " Jtel Providing - Voice Over IP communication enables businesses to receive and make calls through the internet. VOIP communication system eliminates traditional telephone infrastructure, maintenance and hardware discrepancies and allows agents to connect with the customer anywhere through the internet ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"30px","font-weight":"bold"} }, "Jtel Business Phone System", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "mt-4 px-2 px-md-0" }, " Jtel business phone system allows executives to handle customer support queries and sales enquiries in VOIP. Jtel offers business communication solutions through VOIP where you can connect a prospect anywhere globally with affordable cost, quick installation and high reliability. ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"30px","font-weight":"bold"} }, "Jtel Home Phone System", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "mt-4" }, " Connecting you with the moments you live for Plans tailored to meet your needs, whether you only call domestically or internationally too. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_jt_internet_phone_features = _resolveComponent("jt-internet-phone-features")!
  const _component_jt_need_guidance = _resolveComponent("jt-need-guidance")!
  const _component_jt_footer = _resolveComponent("jt-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, { class: "mt-3 mx-0 mx-md-8" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, { src: _imports_0 })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_1,
    _createVNode(_component_v_row, { class: "mt-3 gray-bg" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "7",
          class: "mt-10 px-12"
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "5",
          class: "d-none d-md-flex justify-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, {
              src: _imports_1,
              height: "300px"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { class: "mt-15 mx-8 card-curved" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "5",
          class: "d-flex justify-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, {
              src: _imports_2,
              height: "300px"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "7",
          class: "mt-0 mt-md-10 mb-8"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { class: "mt-15 mb-6 mx-8 card-curved gray-bg" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "7",
          class: "px-6 mt-12"
        }, {
          default: _withCtx(() => [
            _hoisted_6,
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "5",
          class: "d-flex justify-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, {
              src: _imports_3,
              height: "300px"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_jt_internet_phone_features),
    _createVNode(_component_jt_need_guidance),
    _createVNode(_component_jt_footer)
  ], 64))
}